'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _store = require('@utils/store');

var _store2 = _interopRequireDefault(_store);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var location = global.location; /**
                                 * @file Axios的Vue插件（添加全局请求/响应拦截器）
                                 */

// https://github.com/mzabriskie/axios


_axios2.default.defaults.baseURL = _config2.default.api;

_axios2.default.interceptors.request.use(function (config) {
  var token = _store2.default.localStorage.getItem(_store2.default.keys.token);
  if (token) {
    config.headers.token = '' + token;
  }

  return config;
});

_axios2.default.interceptors.response.use(function (response) {

  // 下载文件
  if (response.request.responseType === 'blob') {
    return response;
  }

  var data = response.data;

  switch (data.code) {
    case 0:
    case '0':
      return data;
    case '99':
    case 99:
      break;
    // store.sessionStorage.setItem(store.keys.user, '');
    // return location.href = '/entry/login';
    default:
  }

  var err = new Error(data.msg);

  err.data = data;
  err.response = response;

  throw err;
}, function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        err.message = '请登录';
        break;

      case 404:
        err.message = '\u8BF7\u6C42\u5730\u5740\u51FA\u9519: ' + err.response.config.url;
        break;

      case 500:
      case 503:
        err.message = '服务器错误';
        break;

      case 502:
        err.message = '请求数据超时，请刷新页面重试';
        break;

      default:
    }
  }

  return Promise.reject(err);
});

_axios2.default.install = function (Vue) {
  Vue.prototype.$axios = _axios2.default;
};

exports.default = _axios2.default;


//////////////////
// WEBPACK FOOTER
// ./src/plugins/api.js
// module id = 560
// module chunks = 14